module.exports = __webpack_public_path__ + "static/media/hourglass_blue_full068d28a53ddd2f6905589a4ce087b1f7.webp";